import {connect} from '../../../app/connect';
import IssueRootCausesAdmin from './IssueRootCausesAdmin';
import {
  fetchIssueRootCausesAction,
  updateIssueRootCausesStatusAction,
  deleteIssueRootCauseCategoryAction,
  deleteIssueRootCauseAction,
  toggleRootCauseCategoryInUseModalAction,
  toggleRootCauseInUseModalAction,
  showNotificationAction,
  trackEvent
} from '../../../app/actions';
import {
  getIssueRootCausesDefinitionsEntitiesMap,
  isErrorLoadingIssueRootCausesDefinitions,
  isDeletingRootCausesAdmin,
  showRootCauseInUseModal,
  showRootCauseCategoryInUseModal,
  getFieldAdminPageDataLoading
} from '../../../app/selectors';

const mapStateToProps = state => ({
  data: getIssueRootCausesDefinitionsEntitiesMap(state),
  isLoading: getFieldAdminPageDataLoading(state),
  isDeleting: isDeletingRootCausesAdmin(state),
  error: isErrorLoadingIssueRootCausesDefinitions(state),
  showRootCauseCategoryInUseModal: showRootCauseCategoryInUseModal(state),
  showRootCauseInUseModal: showRootCauseInUseModal(state)
});

const mapDispatchToProps = {
  fetchIssueRootCausesAction,
  updateIssueRootCausesStatusAction,
  deleteIssueRootCauseCategoryAction,
  deleteIssueRootCauseAction,
  toggleRootCauseCategoryInUseModalAction,
  toggleRootCauseInUseModalAction,
  showNotificationAction,
  trackEvent
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssueRootCausesAdmin);
